import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as TipoCambioActions from "../../store/actions/tipoCambio.actions";
import { BannerHero } from "@components";
import { TipoCambio } from "@components";
import { GestionarPagosBanner, ComunicadosOficiales, SobrePagoObligacionesModal } from "@components"
import BarraIntermedia from "../BarraIntermedia/BarraIntermedia";
import Meta from "@components/Meta/Meta";
//import TilesBienesConvenios from "../TilesBienesConvenios/TilesBienesConvenios";
import { isEmpty } from "lodash";
import moment from "moment";
import "moment/locale/es";

moment.locale("es");

function HomeAhorroYCredito(props) {
  const dispatch = useDispatch();
  const [longDate, setLongDate] = useState("");

  const { valores } = useSelector(({ Base }) => Base.TipoCambio);
  const { comunicadosOficiales, gestionPagos } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito.AhorroYCredito
  );

  useEffect(() => {
    dispatch(TipoCambioActions.getTipoCambio());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isEmpty(valores)) {
      var dateData = valores[0]?.xfechA_TIPO_CAMBIO;
      var dateBase = moment(dateData).locale("es").format("dddd LL");
      var dateStr = dateBase.toString();
      var date = dateStr.charAt(0).toUpperCase() + dateStr.slice(1);
      setLongDate(date);
    }
  }, [valores]);

  const defRoute = {
    title: "CS Ahorro y Crédito en Costa Rica",
    description: "Alcance sus metas y objetivos personales, solicitando uno de nuestros préstamos personales y ahorros de CS."
  }

  return (
    <>
      <Meta title={defRoute[0]?.title} description={defRoute[0]?.description} />
      <BannerHero />
      {!isEmpty(valores) && (
        <TipoCambio
          title={"TIPO DE CAMBIO DÓLAR: "}
          longDateStr={longDate}
          curSymbol="₡"
          compra={valores[0]?.xvaloR_COMPRA_INSTITUCION}
          venta={valores[0]?.xvaloR_VENTA_INSTITUCION}
          tasaBasicaPasiva={valores[0]?.xvaloR_COMPRA_OFICIAL}
        />
      )}
      <GestionarPagosBanner valores={gestionPagos}/>
      <BarraIntermedia />
      <ComunicadosOficiales listaComunicados={comunicadosOficiales}/>

    </>
  );
}

export default HomeAhorroYCredito;
